import script from "./addSpare.vue?vue&type=script&setup=true&lang=js"
export * from "./addSpare.vue?vue&type=script&setup=true&lang=js"

import "./addSpare.vue?vue&type=style&index=0&id=43ffc29b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ffc29b"]])

export default __exports__